export const useMenuBuilder = (data: any) => {
  if (!Array.isArray(data)) return [];

  return data
    .filter((item) => item.products && item.products.length > 0)
    .sort((a, b) => {
      const displayRankA = parseInt(a.menu?.display_rank || '0');
      const displayRankB = parseInt(b.menu?.display_rank || '0');
      
      if (displayRankA !== displayRankB) {
        return displayRankA - displayRankB;
      }

      const nameA = a.menu?.name?.toLowerCase() || '';
      const nameB = b.menu?.name?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    })
    .map((item) => ({
      id: item.menu?.id ?? 0,
      name: item.menu?.name ?? `Menu${item.menu.id}`,
      products: item.products
        .sort((a: any, b: any) => {
          const displayRankA = Number(a.display_rank || 0);
          const displayRankB = Number(b.display_rank || 0);
          return displayRankA - displayRankB;
        })
        .map((product: any) => product.product_id)
    }));
};
